const csvTemplate = `outlet_code,brand_id,budget_sample,action
F2F-00002-02SL0001255,5f92628d91fef2cec7caa35d,20000,add
F2F-00002-02SL0001255,5d3ac306a6992471b7c97976,45000,add
F2F-00002-02SL0001255,5d3ac307a6992471b7c97adc,30000,delete
VST-00004-AFO2504001,5d3ac307a6992471b7c97a18,100000,add
VST-00004-AFO2504001,5f92628d91fef2cec7caa35d,150000,add
F2F-00002-A-0015,5d3ac306a6992471b7c97976,25000,add
F2F-00002-A-0015,5d3ac307a6992471b7c97adc,75000,add
F2F-00002-A-0015,5d3ac307a6992471b7c97a18,80000,add`;

export default csvTemplate;
